
import React from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import EmailGenerator from "@/components/emails/EmailGenerator";
import AIDebugPanel from "@/components/AIDebugPanel";
import { Investor, Contact } from "@/types/investor";
import { EmailRecord } from "@/types/email";

interface EmailGeneratorSectionProps {
  investor: Investor | null;
  contacts: Contact[];
  businessInfo: string;
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
  emails?: EmailRecord[];
  onEmailSent: () => void;
}

const EmailGeneratorSection: React.FC<EmailGeneratorSectionProps> = ({
  investor,
  contacts,
  businessInfo,
  isLoading,
  setIsLoading,
  emails = [],
  onEmailSent
}) => {
  if (!investor) return null;
  
  console.log("EmailGeneratorSection - Available contacts:", contacts);
  
  return (
    <Card>
      <CardHeader>
        <CardTitle>Email Generator</CardTitle>
        <CardDescription>
          Generate a personalized email for {investor.name} at {investor.firm}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <EmailGenerator 
          investor={investor}
          contacts={contacts}
          businessInfo={businessInfo}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          apiKey=""
          onApiKeyChange={() => {}}
          onEmailSent={onEmailSent}
          emails={emails}
        />
        
        <AIDebugPanel />
      </CardContent>
    </Card>
  );
};

export default EmailGeneratorSection;
